export enum EmissionFactorMode {
  REALTIME = 'realtime',
  FIXED = 'fixed'
}

export default EmissionFactorMode
